<template>
  <div class="mt-3">
    <v-alert color="error" icon="warning" value="true" v-model="loginError" transition="scale-transition">
      {{$t('login.failed')}}
    </v-alert>
    <v-text-field autofocus name="username" :label="$t('login.username')" :id="idPrefix + 'username'" v-model="username" ></v-text-field>
    <v-text-field name="password" :label="$t('login.password')" :id="idPrefix + 'password'" type="password" @keyup.enter="login" v-model="password"></v-text-field>
    <v-btn :id="idPrefix + 'login-button'" block color="primary" @click="login" dark>{{$t('login.login_button')}}</v-btn>
  </div>
</template>

<script>
import * as actionTypes from '../../store/action-types'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'LoginPanel',
  props: ['idPrefix'],
  data () {
    return {
      username: '',
      password: '',
      startingLogin: false
    }
  },
  computed: {
    ...mapState({
      loggedInUsername: state => state.profile.username,
      loginError: state => state.profile.loginError,
      categories: state => state.intervention.categories
    })
  },
  watch: {
    loggedInUsername (name) {
      // Multiple login panels (page and modal), both will be watching
      if (name && this.startingLogin) {
        this.startingLogin = false
        if (this.categories.length === 0) { // load values if not yet loaded
          this.$store.dispatch(actionTypes.GET_DROPDOWN_VALUES)
        }
        this.fetchAnnouncements()
        this.getEngagementLastSuccessful()
        this.$emit('logged-in')
      }
    }
  },
  methods: {
    login () {
      this.startingLogin = true
      let credentials = { username: this.username, password: this.password }
      this.doLogin(credentials)
    },
    ...mapActions({
      doLogin: actionTypes.LOGIN,
      fetchAnnouncements: actionTypes.FETCH_USER_ANNOUNCEMENTS,
      getEngagementLastSuccessful: actionTypes.GET_ENGAGEMENT_LAST_SUCCESSFUL
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/login/LoginPanel.vue